import React, {Component, Fragment} from "react";
import Radium from "radium";
import PropTypes from "prop-types";
import Translate from "../../../../../components/Translate";

const styles = {
    localeHeadingBorder: {
        borderRight: '1px solid rgba(24,62,153,0.17)',
    },
    localeHeading: {
        height: '54px',
        lineHeight: '60px',
        textAlign: 'center',
        fontSize: '14px',
        fontWeight: 100,
        borderBottom: '1px solid rgba(24,62,153,0.17)',
        WebkitBoxShadow: '1px 3px 3px 0px rgba(24, 62, 153, 0.17)',
        MozBoxShadow: '1px 3px 3px 0px rgba(24, 62, 153, 0.17)',
        boxShadow: '1px 3px 3px 0px rgba(24, 62, 153, 0.17)',
    },
};

class LanguageLabel extends Component {

    constructor(props) {
        super(props)
    }

    render() {
        const {localeOption, fontStyle} = this.props;

        return (
            <Fragment>
                <h2 style={[styles.localeHeading, styles.localeHeadingBorder, fontStyle]}>
                    <Translate text={localeOption.label}/>
                </h2>
            </Fragment>
        )
    }
}


LanguageLabel.propTypes = {
    localeOption: PropTypes.object.isRequired,
    fontStyle: PropTypes.object,
};

export default Radium(LanguageLabel)



// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/management/clients/LanguageLabel.jsx